/**
 * Hilfs-Texte für die Info-Icons im Aktivitäten-Formular.
 * Hier können alle Erklärungstexte zentral bearbeitet werden.
 */
import React from "react";
import { Link } from "react-router-dom";

const activityFormInfoTexts = {
  pageTitle: (
    <>
      Auf dieser Seite können Sie eine neue Freizeitaktivität für Familien in
      Winterthur erfassen. Füllen Sie alle Pflichtfelder (markiert mit *)
      vollständig aus. Die Aktivität wird nach dem Absenden von einem Moderator
      geprüft, bevor sie öffentlich sichtbar wird. Die Prüfkriterien finden Sie
      in den{" "}
      <Link
        to="/aufnahmeregeln"
        style={{ color: "#3b82f6", textDecoration: "underline" }}
      >
        Richtlinien
      </Link>
      . Vielen Dank für Ihren Beitrag zur Freizeitgestaltung von Familien in
      Winterthur!
    </>
  ),

  name:
    "Offizieller Name der Aktivität " +
    "(Beispiel: «Tierpark Goldau besuchen» oder «Klettern in der Kletterhalle Winterthur»)" +
    " oder des Angebots (Beispiel: «Heidi», Film im Kino), wie er den Familien angezeigt wird.",

  description:
    "Kurze Beschreibung der Aktivität oder des Angebots: Was können Familien dort erleben? " +
    "Was ist das Besondere? Idealerweise 2–4 Sätze.",

  website:
    "Direkte URL zur offiziellen Website der Aktivität (z.B. https://gewerbemuseum.ch/de/veranstaltungen/ferien-walk-in-atelier-pop-up-glitzerkarten-erfinden/). " +
    "Muss mit «https://» beginnen. Diese Angabe ist freiwillig.",

  locationName:
    "Name des Standorts oder der Einrichtung, an dem die Aktivität stattfindet. " +
    "Beispiel: ««Gewerbemuseum»» oder «Stadtpark Winterthur».",

  locationAddress:
    "Vollständige Adresse: Strasse, Hausnummer, Postleitzahl und Ort. " +
    "Beispiel: «Geiselweidstrasse 7, 8400 Winterthur». Bitte Format beachten. " +
    "Die Karten-Koordinaten werden automatisch aus der Adresse berechnet. " +
    "Alternativ können statt der Adresse Breite/Länge-Koordinaten eingegeben werden. " +
    "Es gilt immer exklusiv eine Variante: entweder Adresse oder Koordinaten.",

  categories:
    "Wählen Sie alle passenden Kategorien aus – Mehrfachauswahl ist möglich. " +
    "Mindestens eine Kategorie ist erforderlich.",

  ageRange:
    "Für welche Altersgruppe ist diese Aktivität geeignet? " +
    "Stellen Sie das Mindestalter und Höchstalter mit den Reglern ein (0–12 Jahre).",

  weatherType:
    "«Indoor» = ausschliesslich drinnen (wettergeschützt). " +
    "«Outdoor» = ausschliesslich draussen. " +
    "«Wetterunabhängig» = sowohl drinnen als auch draussen oder generell nicht wetterabhängig.",

  cost:
    "Ungefähre Kosten für den Besuch. Wenn Begleitung erforderlich ist, geben Sie die Gesamtkosten an. " +
    "«Gratis» = kostenlos. Ansonsten wählen Sie die passende Preisspanne in CHF.",

  duration:
    "Wie lange dauert ein typischer Besuch dieser Aktivität? " +
    "Wählen Sie den passenden Zeitrahmen.",

  wheelchairAccessible:
    "Ist die Aktivität und der Zugang zum Standort für Personen mit Rollstuhl zugänglich?",
};

export default activityFormInfoTexts;
